import {
    connect,
} from 'react-redux';
import View from './SplitTabsView';
import {
    selectedIndex,
    tabs,
} from './SplitTabsSelector';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedIndex: selectedIndex(state, ownProps),
        tabs: tabs(ownProps),
        setSelectedIndex: ownProps.setSelectedIndex,
    };
};

export default connect(mapStateToProps)(View);
